import { t } from '@lingui/macro';
import { useEnvProvider, ProjectAppTypes, useModulePermission } from '@bechtel/client-common';
import { orderBy } from 'lodash';
import { ProjectAdminMenuItem, ProjectAdminMenuType } from './types';

export interface ProjectAdminMenuUtil {
  getProjectAdminMenuItems(): ProjectAdminMenuItem[];
}

export const workpackagesMenu: ProjectAdminMenuItem = {
  label: t`Work Packages`,
  value: 'work-packages',
  type: ProjectAdminMenuType.WORK_PACKAGES,
  sequenceOrder: 6,
};

export const rodRoomMenu: ProjectAdminMenuItem = {
  label: t`Rod Rooms`,
  value: 'rod-rooms',
  type: ProjectAdminMenuType.ROD_ROOMS,
  sequenceOrder: 9,
};

export const dataVaultMenu: ProjectAdminMenuItem = {
  label: t`Data Vaults`,
  value: 'data-vaults',
  type: ProjectAdminMenuType.DATA_VAULT,
  sequenceOrder: 10,
};

export const reportMenu: ProjectAdminMenuItem = {
  label: t`Reports`,
  value: 'reports',
  type: ProjectAdminMenuType.REPORT,
  sequenceOrder: 11,
};

export function useProjectAdminMenu(): ProjectAdminMenuUtil {
  const { envConfig } = useEnvProvider();
  const { canViewRodRoomModule, canViewReportsModule } = useModulePermission();
  const getProjectAdminMenuItems = () => {
    const projectAdminMenuItems: ProjectAdminMenuItem[] = [
      {
        label: t`General`,
        value: 'general',
        type: ProjectAdminMenuType.GENERAL,
        sequenceOrder: 1,
      },
      {
        label: t`User Admin`,
        value: 'user-admin',
        type: ProjectAdminMenuType.USER_ADMIN,
        sequenceOrder: 2,
      },
      {
        label: t`Modules`,
        value: 'modules',
        type: ProjectAdminMenuType.MODULES,
        sequenceOrder: 3,
      },
      // Uncomment this code when weld setup needed
      // {
      //   label: t`Weld Setup`,
      //   value: 'weld-setup',
      //   type: ProjectAdminMenuType.WELD_SETUP,
      //   sequenceOrder: 4,
      // },
      {
        label: t`Features`,
        value: 'Features',
        type: ProjectAdminMenuType.FEATURES,
        sequenceOrder: 5,
      },
      {
        label: t`Quantity Reporting`,
        value: 'quantity-reporting',
        type: ProjectAdminMenuType.QUANTITY_REPORTING,
        sequenceOrder: 7,
      },
      {
        label: t`Sync`,
        value: 'sync',
        type: ProjectAdminMenuType.SYNC,
        sequenceOrder: 8,
      },
    ];
    if (envConfig.appName === ProjectAppTypes.PF) {
      projectAdminMenuItems.push(workpackagesMenu);
    }
    if (canViewRodRoomModule) {
      projectAdminMenuItems.push(rodRoomMenu);
    }
    if (envConfig.appName === ProjectAppTypes.AS) {
      projectAdminMenuItems.push(dataVaultMenu);
    }
    if (canViewReportsModule) {
      projectAdminMenuItems.push(reportMenu);
    }
    const orderedMenItems = orderBy(projectAdminMenuItems, 'sequenceOrder');
    return orderedMenItems;
  };
  return { getProjectAdminMenuItems };
}
